import { MuiThemeProvider, createTheme, withStyles } from '@material-ui/core';
import { withTheme } from '@material-ui/styles';
import { SearchType } from 'connect/web/src/stores/search-store';
import { action, computed, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import React from 'react';
import type { OnlineClinicService, OnlineServiceCategory } from 'tm3-core/api.dtos';
import type SearchBarStore from '../../stores/search-bar-store';
import styles from './styles';

import { FormControl, MenuItem, TextField } from '@material-ui/core';

interface IProps {
  className: string;
  searchBarStore?: SearchBarStore;
  theme: any;
  classes: { category: string; item: string; itemName: string; services: string };
}

@inject('searchBarStore')
@observer
class Services extends React.Component<IProps> {
  @observable open: boolean = false;

  render() {
    const { searchBarStore, classes } = this.props;
    const { filteredServices } = searchBarStore!;

    return (
      <MuiThemeProvider theme={this.theme}>
        <FormControl className={classes.services}>
          <TextField
            select={true}
            label="Service"
            value={searchBarStore!.serviceId}
            variant="outlined"
            onChange={this.onChange}
            SelectProps={{
              open: this.open,
              onOpen: this.openDropdown,
              onClose: this.closeDropdown
            }}
            fullWidth={true}
          >
            <MenuItem value="All">
              <p className={classes.itemName}>All Services</p>
            </MenuItem>
            {this.generateCategories(filteredServices)}
          </TextField>
        </FormControl>
      </MuiThemeProvider>
    );
  }

  @action.bound
  onChange(e) {
    const { searchBarStore } = this.props;
    const servicePath = e.target.value || '';

    if (!searchBarStore!.filteredTypes.includes(searchBarStore!.searchMode)) {
      searchBarStore!.searchMode = SearchType.Initial;
    }

    if (
      !searchBarStore!.filteredLocations
        .map((f) => f.onlineGuid)
        .includes(searchBarStore!.locationId)
    ) {
      searchBarStore!.locationId = 'All';
    }
    searchBarStore!.serviceId = servicePath;
  }

  @computed
  get theme() {
    const theme = {
      ...this.props.theme,
      overrides: {
        MuiListItem: {
          root: {
            '&$disabled': {
              opacity: 1
            }
          }
        }
      }
    };
    return createTheme(theme);
  }

  @action.bound
  openDropdown(): void {
    this.open = true;
  }

  @action.bound
  closeDropdown(): void {
    this.open = false;
  }

  private generateCategories(
    services: OnlineClinicService[],
    padding: number = 0,
    parentId?: string
  ): any {
    const { classes, searchBarStore } = this.props;
    const { filteredCategories } = searchBarStore!;

    const categoryList =
      parentId == null
        ? filteredCategories.filter((x) => x.parentId == null)
        : filteredCategories.filter((x) => x.parentId === parentId);

    return categoryList.map((x: OnlineServiceCategory) => {
      const newServices = services.filter((y) => x.orderedServices.includes(y.id));

      return [
        <MenuItem key={x.id} disabled={true}>
          <div className={classes.item}>
            <p style={{ paddingLeft: padding }} className={classes.category}>
              {x.title}
            </p>
          </div>
        </MenuItem>,
        this.generateServices(newServices, padding + 5, x.id),
        this.generateCategories(services, padding + 5, x.id)
      ];
    });
  }

  private generateServices(
    elements: OnlineClinicService[],
    padding: number = 0,
    parent?: string
  ): JSX.Element[] {
    const { classes } = this.props;

    return elements.map(({ id, name, classTypeId }, index: number) => {
      return (
        <MenuItem key={index} value={`${id}/${parent}`}>
          <div style={{ paddingLeft: !this.open ? 0 : padding }} className={classes.item}>
            <p className={classes.itemName}>{name}</p>
            {classTypeId > 0 ? (
              <label className={classes.label}>{'Class'}</label>
            ) : (
              <label className={classes.label}>{'Appointment'}</label>
            )}
          </div>
        </MenuItem>
      );
    });
  }
}

export default withTheme(withStyles(styles)(Services));
